export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9338.6b88f88b.jpg";